<ellipse-dynamic-form [dynamicFormConfig]="formConfig"
                      [readonly]="readonly"
                      [viewMode]="viewMode"
                      [formValue]="formValue"
                      (formValueChange)="formValueChanged($event)"
                      (submitForm)="formSubmitted($event)"
/>
